export const SET_DASHBOARD_COUNT = "SET_DASHBOARD_COUNT";
export const RESET_DASHBOARD_COUNT = "RESET_DASHBOARD_COUNT";
export const SET_DASHBOARD_CHART_DATA = "SET_DASHBOARD_CHART_DATA";
export const RESET_DASHBOARD_CHART_DATA = "RESET_DASHBOARD_CHART_DATA";
